import background from 'assets/img/background-login.jpg'
import logoNormal from 'assets/img/logo-normal.svg'
import RequestResetForm from 'forms/Login/RequestResetForm'
import useFetch from 'hooks/useFetch'
import { useToast } from 'hooks/useToast'
import { useEffect, useState } from 'react'

export default function RequestReset() {
  const { showToast } = useToast()

  // useFetch(): hook personalizado para realizar solicitudes GET, POST, PUT, DELETE
  const [requestedReset, requestReset] = useFetch()

  // useState()
  const [error, setError] = useState(null)
  const [showGuide, setShowGuide] = useState(false)

  // CRUD: POST
  const handleSubmit = async (values) => {
    const apiCallParams = {
      url: 'auth/request-reset',
      method: 'POST',
      body: values,
      messageKo: '¡Correo no encontrado!'
    }
    await requestReset(apiCallParams)
  }

  // Escuchar POST
  useEffect(() => {
    if (requestedReset.data) {
      setShowGuide(true)
      setError(null)
    }
  }, [requestedReset.data])

  // Mostrar mensaje API: POST / PUT (notificación de éxito o error)
  useEffect(() => {
    if (requestedReset.isCalled) {
      if (requestedReset.message) {
        showToast(requestedReset.message, 'success')
        setShowGuide(true)
      }

      if (requestedReset.error) {
        showToast(requestedReset.error, 'error')
        setError('¡Usuario no encontrado!')
      }
    }
  }, [requestedReset.loading])

  return (
    <div className="flex items-center w-screen h-dvh">
      <div
        className="fixed z-10 block w-full h-full bg-top brightness-50"
        style={{
          background: `url(${background})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover'
        }}
      />

      <div className="relative z-50 flex items-center justify-center w-full">
        <div className="w-11/12 max-w-lg overflow-hidden bg-white rounded-lg shadow-lg sm:w-full dark:lg:bg-gray-800">
          <div className="flex justify-center w-full p-0">
            <div className="w-full h-24 overflow-hidden border-4 border-white rounded-t-lg bg-base">
              <img
                className="pb-1 mx-auto -mt-4 size-32"
                src={logoNormal}
                alt="Claim Sphere"
              />
            </div>
          </div>

          <RequestResetForm
            showGuide={showGuide}
            error={error}
            requestedReset={requestedReset}
            handleSubmit={handleSubmit}
          />
        </div>
      </div>
    </div>
  )
}
